<div *ngIf="isLoaded; else loading" class="max-w_960px">
  <div class="modal_title_container" mat-dialog-title>
    <div class="pop_options">
      <ng-container *ngFor="let title of navTitles; let index = index">
        <input value="title_box" type="hidden" />
        <div class="title_box" [ngClass]="{active: selectedTab === title, 'c-d': data.mode !== 'edit'}">
          <div class="wizard_number" *ngIf="data.mode !== 'edit'">
            <div>{{ index + 1 }}</div>
          </div>
          <div>{{ title }}</div>
        </div>
      </ng-container>
    </div>
    <i class="icon-close" (click)="onClose()"></i>
  </div>

  <div class="onboard_info_container p-0" mat-dialog-content>
    <ng-container [ngSwitch]="selectedTab">
      <div class="sub_container" *ngSwitchDefault>
        <app-provider-account-info
          [provider]="provider"
          [organizationId]="data.organizationId"
          [accountId]="data.provider ? data.provider.id : null"
          [mode]="data.mode"
          (next)="nextTab($event)"
          (back)="backTab($event)"
          (hideTabs)="hideTabs($event)"
          (close)="onClose($event)"
        ></app-provider-account-info>
      </div>
      <div class="sub_container" *ngSwitchCase="labels.profile">
        <app-provider-profile
          #providerProfile
          (delete)="deleteProvider()"
          (next)="providerProfileNext($event)"
          (back)="backTab($event)"
          [organizationId]="data.organizationId"
          [provider]="provider"
        ></app-provider-profile>
      </div>

      <div class="sub_container" *ngSwitchCase="labels.locations">
        <app-provider-locations
          [provider]="provider"
          [orgId]="this.data.organizationId"
          (next)="finishEvent($event)"
          (back)="backTab($event)"
        ></app-provider-locations>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <skeleton-loader type="modal-1"></skeleton-loader>
</ng-template>
